exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k2F6JzMEXBX0gV{padding:4px;margin-bottom:4px;border-bottom:1px solid rgba(9,30,66,.13)}._1naoA79-kOYGq0 h3,._1naoA79-kOYGq0 p{margin:0 0 8px}._1NvrVtO_uzP5bl,._1NvrVtO_uzP5bl a{color:#6b778c}._1NvrVtO_uzP5bl a:not(._1jaWBTj2HV8Swt):hover{color:#172b4d}.WAtTKZjXWqeDAW{background-color:#e9e9e9}._3ze2ze99qE77nA{text-decoration:none}._3ze2ze99qE77nA:hover{text-decoration:underline}._3hB9MpPm_1Ch6g{margin:10px 0 0}._1dDSVwXBLm4T0d{border-radius:3px;color:#6b778c;display:block;float:left;height:20px;font-size:16px;font-weight:700;line-height:20px;padding:10px 10px 10px 36px;position:relative;text-align:center}._1dDSVwXBLm4T0d:hover{background-color:#dfe1e6;color:#172b4d}.vo0k6_qWoNpUDr{position:absolute;top:5px;left:5px}._4j2H-zlAnURked{border-radius:3px;display:block;float:left;height:30px;padding:5px 8px;text-align:center}._4j2H-zlAnURked:hover{background-color:#dfe1e6}._3sIDM1WjJHzX2g{max-height:311px;overflow-x:hidden;overflow-y:auto;padding:0 12px 12px}", ""]);

// exports
exports.locals = {
	"announcement": "k2F6JzMEXBX0gV",
	"announcement-blog": "_1naoA79-kOYGq0",
	"quiet": "_1NvrVtO_uzP5bl",
	"disabled": "_1jaWBTj2HV8Swt",
	"announcement-downtime": "WAtTKZjXWqeDAW",
	"announcementHeaderLink": "_3ze2ze99qE77nA",
	"announcement-elsewhere": "_3hB9MpPm_1Ch6g",
	"announcement-elsewhere-blog": "_1dDSVwXBLm4T0d",
	"announcement-elsewhere-blog-icon": "vo0k6_qWoNpUDr",
	"announcement-elsewhere-social": "_4j2H-zlAnURked",
	"popoverContent": "_3sIDM1WjJHzX2g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/popovers/announcements/announcement.less
// module id = GmLg
// module chunks = 24